import template from './errorPage.html';
import controller from './errorPage.controller';
import './errorPage.scss';

let errorPageComponent = {
  restrict: 'E',
  template,
  controller
};

export default errorPageComponent;



// WEBPACK FOOTER //
// ./client/app/features/errorPage/errorPage.component.js